


























































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { IMember } from "@/types/member";

@Component({
  components: {},
})
export default class extends Vue {
  @Getter("member/single")
  public member!: IMember;

  @Action("progress/flipStatus")
  public progress!: (progress_id: number) => Promise<boolean>;

  @Action("member/adminGet")
  public getMember!: (id: number) => void;

  public member_id = 0;

  public created() {
    this.member_id = Number(this.$route.params.member_id);
  }

  public async updateProgress(id: number) {
    await this.progress(id);
    await this.getMember(this.member_id);
  }
}
